import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const PreviewSettings = () => {
  const { user, setUser } = useAuth();
  const [usage, setUsage] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/previews/usage").then(({ data }) => setUsage(data)).catch(() => {}); }, []);

  const toggle = async (enabled) => {
    setSaving(true);
    try {
      await api.put("/settings/preview", { enabled });
      setUser({ ...user, preview_enabled: enabled });
      toast.success(enabled ? "Previews turned on" : "Previews turned off");
    } catch (e) { toast.error(errorMessage(e)); }
    finally { setSaving(false); }
  };

  return (
    <section className="rounded-2xl border bg-card p-5 shadow-soft sm:p-6" data-testid="preview-settings">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="text-base font-semibold text-foreground">Finished-space preview</h2>
          <p className="mt-0.5 text-sm text-muted-foreground">Homeowners can see an AI illustration of their space after the job (visual services only).</p>
        </div>
        <Switch checked={user.preview_enabled} disabled={saving} onCheckedChange={toggle} data-testid="preview-toggle" aria-label="Show finished-space preview to homeowners" />
      </div>
      <p className="mt-3 text-sm font-medium text-foreground">Show finished-space preview to homeowners</p>
      {usage && (
        <div className="mt-4">
          <p className="text-sm text-muted-foreground" data-testid="preview-usage">{usage.used} of {usage.limit} previews used this month</p>
          <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-muted">
            <div className="h-full rounded-full bg-[color:var(--brand)] transition-[width]" style={{ width: `${Math.min(100, (usage.used / usage.limit) * 100)}%` }} />
          </div>
        </div>
      )}
    </section>
  );
};
